import { ListDataSource } from "../dataAccess/DataSource";
import { LoggerFactory } from "../logger";

const log = LoggerFactory.create("simple select list");

export class GenerateSimpleSelectList {
  public dataSource: ListDataSource<{}, {}>;
  public labelField: string;
  public valueField: string;
  private list: {
    label: any;
    value: string | number | boolean | undefined | null;
  }[] = [];

  constructor(
    dataSource: ListDataSource<{}, {}>,
    labelField: string,
    valueField: string
  ) {
    this.dataSource = dataSource;
    this.labelField = labelField;
    this.valueField = valueField;

    this.dataSource
      .findAll({ filters: [], page: { pageSize: 1000, pageNumber: 0 } }, true)
      .then(() => {
        for (const row of this.dataSource.list) {
          this.list.push({
            label: row[this.labelField],
            value: row[this.valueField]
          });
        }
      })
      .catch(() => {
        log.debug("Can not process data from db");
      });
  }

  public getSilplyfiedList() {
    log.debug("list!!");
    return this.list;
  }
}
